import { Break } from "../../styled/Break";
import React, { ReactElement } from "react";
import { Center, Image, SimpleGrid } from "@chakra-ui/react";
import { FormikStep } from "../FormikStepper";
import { ObjectSchema } from "yup";
import { InputField } from "../../common/form_fields/InputField";
import { TextAreaField } from "../../common/form_fields/TextAreaField";
import { useFormikContext } from "formik";
import { ImageUploadButton } from "../../create_homebrew/image_upload/ImageUploadButton";
import { useAuthState } from "../../../context/AuthState";
import { SetBoolean, SetElement, SetState } from "../../../Types";
import { uploadImage } from "../../../api/common";
import { useAlertContext } from "../../../context/Alert";

interface Props {
  validationSchema: ObjectSchema<any>;
  submitDisabled: boolean;
  setSubmitDisabled: SetBoolean;
  setTitle?: (name: string) => void;
  preview: string;
  setPreview: SetState<string>;
}

export function Flavor({ setTitle, setSubmitDisabled, submitDisabled, setAlert, preview, setPreview }: Props): ReactElement {
  const formikProps = useFormikContext();
  const authState = useAuthState();
  const userId = authState.id || "";
  const key = `${userId}/${Math.floor(Math.random() * 100000000000)}`;
  const { addAlert } = useAlertContext();

  const onSuccess = (presignedUrl: string) => {
    formikProps.setFieldValue("previewS3Key", key);
    setSubmitDisabled.off();
    addAlert(true, "Uploaded monster image!");
  };

  const onFailure = (error) => {
    addAlert(false, `Something with wrong with uploading image ${error}`);
  };

  const imageCallback = (image: Blob) => {
    setPreview(URL.createObjectURL(image));
    setSubmitDisabled.on();
    uploadImage(image, key, onSuccess, onFailure);
  };

  return (
    <FormikStep label="Flavor" isLoading={false}>
      <SimpleGrid columns={{ md: 1, lg: 2 }} spacing="5vw">
        <InputField
          type="text"
          name="name"
          label="Name"
          callback={(name) => setTitle(name)}
          borderColor="monster.primary"
          borderHoverColor="monster.primaryHover"
        />
        <InputField type="text" name="motivation" label="Motivation" borderColor="monster.primary" borderHoverColor="monster.primaryHover" />
      </SimpleGrid>
      <Break height="5vh" />
      <ImageUploadButton
        callback={imageCallback}
        key={key}
        submitDisabled={submitDisabled}
        background="monster.primary"
        hoverBackground="monster.primaryHover"
      />
      <Center>
        <Image src={preview} maxH="40vh" />
      </Center>
      <Break height="5vh" />
      <TextAreaField
        name="description"
        label="Description"
        borderColor="monster.primary"
        borderHoverColor="monster.primaryHover"
        placeholder="How would you describe facing this monster?"
      />
    </FormikStep>
  );
}
